<template>
	<div>
		<div class="flex">
			<div class="logo-box"><img class="logo-img" src="@/assets/images/logo.png" alt="">
			新路线系统
			</div>
			<div class="header-box flex">
				<img class="menu" src="@/assets/images/menu.png" alt="" @click="handleMenu">
					<el-tag class="ml10 index-tag" :class="active=='home'?'active' : ''" @click="handleIndex">
						首页
					</el-tag>

				<div class="menu-list" ref="scrollRef">
					<el-tag v-for="(item,i) in menuList" ref="tab" :key="i" :class="active == item.route ? 'active' : ''"
						@click="clickMenu(item.route)" @close="handleClose(item,i)" :closable="item.route == 'home' ? false : true">
						{{item.title}}
					</el-tag>
				</div>

					<div class="user-info-div flex">
				<!--组织部门  -->
				<div>
					<el-popover placement="bottom" width="350" trigger="hover">
						<div>
							<div class="company-title ">{{userInfo.userCode}} <br> {{groupName}}</div>
							<div class="bottom-line"></div>
							<div class="flex mt10">
								<div class="company-user">
									<div class="company-desc">姓名</div>
									<div class="company-title mt5">{{userInfo.userName}}</div>
								</div>
								<div class="ml10">
									<div class="company-desc">角色</div>
									<div class="company-title mt5">{{roleName}}</div>
								</div>
							</div>
							<div class="bottom-line"></div>
							<div class="mt10">
								<div class="company-desc">当前组织部门</div>
								<div class="company-title mt5 pointer" @click="showGroupTree">{{groupName}} <i class="el-icon-caret-bottom"></i></div>
							</div>
						</div>
						<div slot="reference">{{groupName}}<i class="el-icon-caret-bottom secant"></i> <span
								class="ml5 secant">|</span> </div>
					</el-popover>
				</div>
				<!-- 个人中心 -->
				<div class="person-center">
					<el-dropdown @command="handleCommand">
						<span class="el-dropdown-link">
							<img class="user-icon" src="@/assets/images/13.png" alt="">
							<span class="name ml5">{{name}}</span>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="a">退出登录</el-dropdown-item>
							<el-dropdown-item command="b">修改密码</el-dropdown-item>

						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
			</div>
		</div>

		<edit-pass ref="editPass"></edit-pass>
		<!--组织树 -->
		<groupTree v-if="groupTreeDialog" ref="groupTree" @groupIdListener="groupIdCallback"
			@groupNameListener="groupNameCallback">
		</groupTree>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'
	import groupTree from '@/components/groupTree/index.vue';
	import editPass from '@/components/EditPassword'
	export default {
		components: {
			editPass,
			groupTree,
		},
		data() {
			return {
				name: JSON.parse(window.sessionStorage.userInfo).userName,
				show: false,
				active: 'home',
				menuList: [
				// 	{
				// 	title: '首页',
				// 	route: 'home'
				// }
				],
				groupTreeDialog: false,
				treeData: [],
				roles: JSON.parse(window.sessionStorage.roles),
				roleName: '',
				groupName: window.sessionStorage.groupName,
				userInfo: JSON.parse(window.sessionStorage.userInfo)
			}
		},
		computed: {
			...mapGetters([
				'menushow','catch_components'
			]),
		},
		watch: {
			$route(from, to) {
				let index = this.menuList.findIndex((item) => item.route == from.name);
				if(from.name!='home'){
					if (index == -1) {
						this.menuList.push({
							title: from.meta.title,
							route: from.name
						})
					}
				}

				this.active = from.name;
				window.sessionStorage.setItem('currentName', this.active);
				window.sessionStorage.setItem('menuList', JSON.stringify(this.menuList));
				this.moveToCurrentTab()
			}
		},
		created() {
			this.init();
			this.getTree()
		},
		methods: {
			init() {
				let role = [];
				this.roles.forEach(item => {
					role.push(item.name)
				})
				this.roleName = role.join(',');
				if (window.sessionStorage.getItem('menuList')) {
					this.menuList = JSON.parse(window.sessionStorage.getItem('menuList'));
					this.active = window.sessionStorage.getItem('currentName');
				}
			},
			// 侧边栏效果
			handleMenu() {
				this.$store.commit('app/SET_MENU');
			},
			handleIndex(){
				this.active = 'home';
				this.$router.push({
					name: 'home'
				})
			},
			clickMenu(name) {
				this.active = name;
				this.$router.push({
					name: name
				})
			},
			handleClose(dt, i) {
				// console.log(dt,i)
				if (this.menuList.length <= 0) {
						this.active = 'home';
				}else{
					if (this.active == dt.route) {
						if(i>0){
							this.active = this.menuList[i - 1].route;
						}
						else{
							this.active ='home'
						}
					}
					this.menuList.splice(i, 1);
				}
				this.$router.push({
				name: this.active
				})
				window.sessionStorage.setItem('menuList',JSON.stringify(this.menuList))
				this.$store.commit("app/removeKeepAliveCache", dt.route);
			},
			// 个人中心点击
			handleCommand(command) {
				if (command == 'a') {
					this.handleBack()
				} else {
					this.editPwd()
				}
			},
			// 修改密码
			editPwd() {
				this.$refs.editPass.init(true);
			},
			// 退出登录
			handleBack() {
				this.$confirm('是否退出登录?', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					window.sessionStorage.clear();
					this.$store.commit('app/SET_CACHE',[]);
					this.$router.push({
						name: 'login'
					})
				}).catch(() => {

				});
			},
			// 获取组织树
			getTree() {
				let that = this;
				that.$request.post(
						"changeTree",
						false, {}
					)
					.then((res) => {
						if (res) {
							that.treeData = res.data
						}
					})
			},
			// 组织树
			showGroupTree() {
				this.groupTreeDialog = true;
				this.$nextTick(() => {
					this.$refs.groupTree.init(this.treeData);
				});
			},
			// groupId回调
			groupIdCallback(val) {
				window.sessionStorage.setItem('groupId', val);

			},
			// groupName回调
			groupNameCallback(val) {
				this.groupName = val;
				window.sessionStorage.setItem('groupName', val);
				window.location.reload();
			},
			moveToCurrentTab() {
				this.$nextTick(() => {
						document.querySelector(".el-tag.active").scrollIntoView({
						behavior: "smooth",
					});

				})
			},
		}
	}

</script>
<style lang="scss" scoped>
	.app-header {
		width: 100%;
		// line-height: 48px;
		align-items: center;
		// justify-content: space-between;
	}
	.logo-box{
		width: 200px;
		min-width: 200px;
		color: #fff;
		font-weight: bold;
		background-color: rgba(27, 201, 181, 1);
		height: 48px;
		line-height: 48px;
		text-align: center;
	}
	.logo-img{
		width: 63px;
		height: 33px;
		vertical-align:middle;
	}
	.header-box{
		width: calc(100% - 200px);
		// align-items: center;
	}

	.menu {
		cursor: pointer;
		width: 24px;
		height: 18px;
		margin-left: 18px;
		vertical-align: middle;
		margin-top: 13px;
	}

	.menu-list {
		// margin-left: 10px;
		// height: 32px;
		// width: calc(100% - 810px);
		flex: 1;
		overflow-x: scroll;
		overflow-x: overlay;
		overflow-y: hidden;
		vertical-align: middle;
		white-space: nowrap;
		scrollbar-color: #e5e5e5 #f7f7f9; /* 滑块颜色  滚动条背景颜色 */
		scrollbar-width: thin; /* 滚动条宽度有三种：thin、auto、none */
		margin-top: 10px;
		// &::-webkit-scrollbar{
		//   display: none;
		// }
		&::-webkit-scrollbar {
			width: 0;
			height: 4px;
		}

		&::-webkit-scrollbar-track {
			border-radius: 2px;
		}

		&::-webkit-scrollbar-thumb {
			background: #ddd;
			border-radius: 5px;
		}

		&::-webkit-scrollbar-thumb:hover {
			background: #bbb;
		}

		.el-tag {
			display: inline-block;
			border-radius: 28px;
			height: 28px;
			line-height: 27px;
			font-size: 13px;
			color: #000;
			border-color: #ddd;
			background-color: #fff;
			margin-right: 5px;
			cursor: pointer;

			/deep/ .el-icon-close {
				color: #aaa;
			}

			/deep/ .el-tag__close:hover {
				color: #fff;
				background-color: #ccc;
			}
		}
		.active {
			color: rgba(27, 201, 181, 1);
			border-color: rgba(27, 201, 181, 0.2);
			background-color: rgba(27, 201, 181, 0.1);

			/deep/ .el-icon-close {
				color: rgba(27, 201, 181, 1);
			}

			/deep/ .el-tag__close:hover {
				color: #fff;
				background-color: rgba(27, 201, 181, 1);
			}
		}

	}

	.user-info-div {
		max-width: 650px;
		cursor: pointer;
		justify-content:flex-end;
		margin-left: 10px;

		.user-icon {
			width: 28px;
			vertical-align: 8px;
		}

		line-height: 45px;

		.user-span {
			display: inline-block;
			margin-left: 4px;
			width: 100px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			vertical-align: bottom;
		}

		.user-ul {
			position: absolute;
			width: 135px;
			background-color: #fff;
			box-shadow: 0px 5px 10px #aaa;
			top: 49px;
			// left: -5px;
			z-index: 10;

			li {
				list-style: none;
				text-align: center;
				cursor: pointer;
				line-height: 40px;
				font-size: 14px;
			}
		}
	}

	.name {
		display: inline-block;
		font-weight: 400;
		color: rgba(0, 0, 0, .72);
		font-size: 16px;
		max-width: 200px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.person-center {
		min-width: 100px;
		// margin-right: 10px;
		height: 48px;
		// line-height: 48px;
		padding: 0 10px;
	}
	.el-dropdown{
		height: 48px;
	}
	.company-title {
		font-size: 16px;
		font-weight: 400;
		color: #333333;
	}

	.bottom-line {
		border-bottom: 1px solid #ECECEC;
		padding: 5px;
	}

	.company-user {
		width: 130px;
	}

	.company-desc {
		font-size: 14px;
		color: #666666;
	}

	.secant {
		color: rgba($color: #000000, $alpha: 0.35);
	}
	.index-tag{
		margin-top: 10px;
		border-radius: 28px;
		height: 28px;
		line-height: 27px;
		font-size: 13px;
		color: #000;
		border-color: #ddd;
		background-color: #fff;
		margin-right: 5px;
		cursor: pointer;
		&.active {
			color: rgba(27, 201, 181, 1);
			border-color: rgba(27, 201, 181, 0.2);
			background-color: rgba(27, 201, 181, 0.1);

			/deep/ .el-icon-close {
				color: rgba(27, 201, 181, 1);
			}

			/deep/ .el-tag__close:hover {
				color: #fff;
				background-color: rgba(27, 201, 181, 1);
			}
		}
	}
</style>
